var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-title"},[_c('h6',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.text))]),_c('hr',{staticClass:"form-title"})])}
var staticRenderFns = []

export { render, staticRenderFns }